import * as DevToolsToolbar from "./DevToolbar";

export const DevToolbar: React.ComponentType =
  process.env.NODE_ENV === "development"
    ? DevToolsToolbar.DevToolbar
    : function () {
        return null;
      };
